import { createRoot } from 'react-dom/client'
import { LegacyApp } from './legacy/LegacyApp'

createRoot(document.getElementById('root')!).render(<LegacyApp />)
